import { render, staticRenderFns } from "./CreditNoteShop.vue?vue&type=template&id=6b181b19&scoped=true"
import script from "./CreditNoteShop.vue?vue&type=script&lang=js"
export * from "./CreditNoteShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b181b19",
  null
  
)

export default component.exports